module.exports = __webpack_public_path__ + "img/警告.17742000.svg";